import { ParameterSortingValuesE } from 'declarations/enums/tickets';

export const COLUMN_LABEL_TO_SORT_PARAM: Record<string, ParameterSortingValuesE> = {
  P: ParameterSortingValuesE.TicketPriority,
  RO: ParameterSortingValuesE.RONumber,
  VIN: ParameterSortingValuesE.Vin,
  Line: ParameterSortingValuesE.LineNumber,
  Age: ParameterSortingValuesE.Age,
  'Claim Age': ParameterSortingValuesE.ClaimAge,
  'Closed RO Age': ParameterSortingValuesE.ClosedROAge,
  Status: ParameterSortingValuesE.Status,
  Assignee: ParameterSortingValuesE.Assignee,
  Category: ParameterSortingValuesE.RequestCategory,
  'Claim Status': ParameterSortingValuesE.ClaimStatus,
  Amount: ParameterSortingValuesE.Amount,
  Advisor: ParameterSortingValuesE.Advisor,
  Tech: ParameterSortingValuesE.Tech,
  Attachment: ParameterSortingValuesE.HasAttachment,
  Approved: ParameterSortingValuesE.IsApprovedByDealer,
  'Closed RO Date': ParameterSortingValuesE.ClosedROAge,
};

export const NON_SORTABLE_COLUMN_LABELS = new Set([
  'Last Comment',
  'Audit Trail',
  'Subcategory',
  'Account',
]);

export const CHECKBOX_COLUMN_WIDTH_PX = 56;
export const VIEWED_INDICATOR_COLUMN_WIDTH_PX = 28;
export const FIXED_COLS_WIDTH_PX = CHECKBOX_COLUMN_WIDTH_PX + VIEWED_INDICATOR_COLUMN_WIDTH_PX;

export const COLUMN_WIDTH_WEIGHTS: Record<string, number> = {
  P: 1,
  RO: 3,
  VIN: 4,
  Line: 2,
  Age: 2,
  'Claim Age': 4,
  'Closed RO Age': 6,
  'Closed RO Date': 5,
  Status: 3,
  Assignee: 4,
  Category: 5,
  'Last Comment': 6,
  'Claim Status': 5,
  Amount: 4,
  Advisor: 4,
  Tech: 3,
  Attachment: 2,
  Approved: 4,
  Subcategory: 5,
  Account: 4,
  'Audit Trail': 5,
};

export const COLUMN_MIN_WIDTH_PX: Record<string, number> = {
  P: 24,
  RO: 44,
  VIN: 64,
  Line: 56,
  Age: 44,
  'Claim Age': 76,
  'Closed RO Age': 110,
  'Closed RO Date': 92,
  Status: 60,
  Assignee: 72,
  Category: 76,
  'Last Comment': 37,
  'Claim Status': 82,
  Amount: 60,
  Advisor: 64,
  Tech: 48,
  Attachment: 52,
  Approved: 76,
  Subcategory: 76,
  Account: 64,
  'Audit Trail': 64,
};

type ColumnLike = { label: string };

export function getTotalWeight(visibleColumns: ColumnLike[]): number {
  return visibleColumns.reduce((sum, col) => sum + (COLUMN_WIDTH_WEIGHTS[col.label] ?? 5), 0);
}

export function getMinTableWidthPx(visibleColumns: ColumnLike[]): number {
  const dataColsMin = visibleColumns.reduce(
    (sum, col) => sum + (COLUMN_MIN_WIDTH_PX[col.label] ?? 56),
    0
  );
  return CHECKBOX_COLUMN_WIDTH_PX + dataColsMin;
}

export function getDataColumnWidth(label: string, totalWeight: number): string {
  const weight = COLUMN_WIDTH_WEIGHTS[label] ?? 5;
  const pct = (weight / totalWeight) * 100;
  const fixedShare = (weight / totalWeight) * CHECKBOX_COLUMN_WIDTH_PX;
  return `calc(${pct}% - ${fixedShare}px)`;
}

export function getDataColumnWidthPx(
  label: string,
  totalWeight: number,
  dataColumnsTotalWidthPx: number
): number {
  const weight = COLUMN_WIDTH_WEIGHTS[label] ?? 5;
  const proportional = Math.round((weight / totalWeight) * dataColumnsTotalWidthPx);
  const minPx = COLUMN_MIN_WIDTH_PX[label] ?? 0;
  return Math.max(minPx, proportional);
}
